import averageEmoji from '@/assets/images/emoji/average.png';
import excellentEmoji from '@/assets/images/emoji/excellent.png';
import goodEmoji from '@/assets/images/emoji/good.png';
import poorEmoji from '@/assets/images/emoji/poor.png';
import type { SubSection } from '@/types/Product.types';

const colors = {
  transparent: 'transparent',
  trueGreen: '#008418',
  lightGreen: '#23BB75',
  yellow: '#F4B619',
  orange: '#FF6800',
  red: '#D30101',
};

const STORE_RATING_WEIGHTS = {
  RETURN: 0.6,
  SHIPPING: 0.4,
  COD: 0.2,
};

export const getRatingColor = (
  rating: string | number | null | undefined
): string => {
  if (rating == null || rating === '') return colors.transparent;
  const numRating = Number(rating);
  if (isNaN(numRating)) return colors.transparent;

  if (numRating >= 4.0) return colors.trueGreen;
  if (numRating >= 3.4) return colors.lightGreen;
  if (numRating >= 2.7) return colors.yellow;
  if (numRating >= 2.0) return colors.orange;
  return colors.red;
};

export const getRatingEmoji = (
  rating: string | number | null | undefined
): string | null => {
  if (rating == null || rating === '') return null;
  const numRating = Number(rating);
  if (isNaN(numRating)) return null;

  if (numRating >= 4.0) return excellentEmoji;
  if (numRating >= 3.4) return goodEmoji;
  if (numRating >= 2.7) return averageEmoji;
  return poorEmoji;
};

export const formatRatingStr = (
  rating: string | number | null | undefined
): string => {
  if (rating == null || rating === '') return '';

  const numRating = Number(rating);
  if (isNaN(numRating)) return String(rating);

  return numRating.toFixed(1);
};

export const calculateStoreRating = (
  deliveryDetails: SubSection[] | null | undefined
): string | null => {
  if (!deliveryDetails || deliveryDetails.length === 0) return null;

  let returnScore = 0;
  let shippingScore = 0;
  let codScore = 0;

  deliveryDetails.forEach((sub: SubSection) => {
    const sheetTitle = (sub.sheetTitle || '').toUpperCase();
    const score = Number(sub.score) || 0;

    if (sheetTitle.includes('RETURN')) {
      returnScore = Math.max(returnScore, score);
    } else if (sheetTitle.includes('CASH') || sheetTitle.includes('COD')) {
      codScore = Math.max(codScore, score);
    } else if (
      sheetTitle.includes('FULFILL') ||
      sheetTitle.includes('SHIPPING') ||
      sheetTitle.includes('DELIVERY')
    ) {
      shippingScore = Math.max(shippingScore, score);
    }
  });
  const totalScore =
    returnScore * STORE_RATING_WEIGHTS.RETURN +
    shippingScore * STORE_RATING_WEIGHTS.SHIPPING +
    codScore * STORE_RATING_WEIGHTS.COD;
  if (totalScore <= 0) return null;

  let rating = (totalScore / 3.6) * 5.0;
  if (rating > 5.0) rating = 5.0;

  return rating.toFixed(1);
};
